import React from "react";
import {connect} from "react-redux";
import {filterRegion} from "../../actions/filter";

class Filter extends React.Component {
    render() {

        return (
          <div className="container">
              <div className="rob-filter__row">
                  <div className="rob-filter__intro">
                      <h1> Keep up with the latest news and updates in Adolescent / Young Adult cancer from around New Zealand.</h1>
                  </div>
              </div>

          </div>
        )
    }
}

function mapStateToProps(state) {
    return {
    };
}

export default connect(mapStateToProps, {filterRegion})(Filter);




// WEBPACK FOOTER //
// ./src/components/elements/Filter.js